import { createStyles } from 'antd-style';

import { ThemeColors } from '../../theme';

export const useShipmentMilestonesStepsStyles = createStyles(() => ({
  shipmentMilestonesSteps: {
    '.MilestoneStepper-Titles *:not(:first-child):not(:last-child)': {
      color: ThemeColors.COLOR_GREY_BLUISH,
    },
  },
}));
